// extracted by mini-css-extract-plugin
module.exports = {"root":"map_root__3qcrq","marker":"map_marker__EnBz1","floatCard":"map_floatCard__1zZP1","icon":"map_icon__NHzYD","point":"map_point__GfLMi"};